import type { ConceptDef } from '../types';

export const mandAttention: ConceptDef = {
  kind: 'supervisorScored',
  id: 'mand-attention',
  label: 'Mand Attention',
  category: 'Mand',
  description: 'Adult is busy; learner gets attention politely. Supervisor scores.',
  config: {
    promptMode: 'TEXT',
    prompts: [
      { prompt: 'Adult is reading a book.', hint: 'Expect: "Excuse me."' },
      { prompt: 'Adult is on the phone.' },
      { prompt: 'Adult is talking to someone else.' },
      { prompt: 'Adult is looking the other way.' },
    ],
  },
};
